import PropTypes from "prop-types";
import cs from "classnames";
import styles from "./session-expired.module.scss";

import { Button } from "@lululemon/ui-library";

const SessionExpired = ({ isLoggedIn, messages, buttonProps }) => {
  const {
    loggedInButtonText,
    anonButtonText,
    signInUrl,
    headerText,
    timeoutDescription,
    ctaCallBack
  } = messages;

  const buttonText = isLoggedIn ? loggedInButtonText : anonButtonText;

  return (
    <div className={cs(styles.container, "OneLinkNoTx")}>
      <h1 className={cs("lll-type-heading-medium", styles.heading)}>
        {headerText}
      </h1>
      <p
        className={cs("lll-type-body-large", styles.copy)}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: timeoutDescription
        }}
      />

      <Button
        mobileBlock
        variant="filledImpact"
        href={isLoggedIn ? signInUrl : null}
        onClick={isLoggedIn ? null : ctaCallBack}
        className={styles.sessionExpiryCta}
        {...buttonProps}
      >
        {buttonText}
      </Button>
    </div>
  );
};

SessionExpired.propTypes = {
  isLoggedIn: PropTypes.bool,
  messages: PropTypes.shape({
    loggedInButtonText: PropTypes.string,
    anonButtonText: PropTypes.string,
    signInUrl: PropTypes.string,
    headerText: PropTypes.string,
    timeoutDescription: PropTypes.string,
    ctaCallBack: PropTypes.func
  }),
  // eslint-disable-next-line react/forbid-prop-types
  buttonProps: PropTypes.object
};

export default SessionExpired;
